/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const FolderIcon = /*#__PURE__*/ createSvgIcon(
  'FolderIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.5 16a1.44 1.44 0 01-1.052-.448A1.44 1.44 0 012 14.5v-9c0-.412.15-.766.448-1.06.299-.293.65-.44 1.052-.44h3.867c.2 0 .39.035.57.104.181.07.348.18.5.333L10 6h6.5c.413 0 .766.147 1.06.44.293.294.44.647.44 1.06v7c0 .403-.147.754-.44 1.052A1.433 1.433 0 0116.5 16h-13zm0-1.5h13v-7H9.375l-2-2H3.5v9z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default FolderIcon;
